import type { DownloadedFile } from '@/api/httpClient';

/**
 * Livraison du fichier d'export du journal.
 *
 * Le fichier traverse le client HTTP authentifie (`asFile`) plutot qu'un lien :
 * un `<a href>` n'emporterait pas le jeton Bearer, que l'API est seule a
 * accepter. Il est ensuite remis au navigateur par une URL d'objet, revoquee
 * aussitot.
 */

export const FALLBACK_EXPORT_NAME = 'journal-audit.csv';

/** Nom propose par le serveur (`Content-Disposition`), ou un nom par defaut. */
export const exportFilename = (headers: Headers): string => {
  const disposition = headers.get('Content-Disposition') ?? '';
  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/iu.exec(disposition);
  const name = match?.[1]?.trim() ?? '';

  // Un nom de fichier n'est jamais un chemin : tout ce qui precede un separateur est ecarte.
  const base = name.split(/[\\/]/u).pop() ?? '';

  return base === '' ? FALLBACK_EXPORT_NAME : base;
};

/** `X-Truncated: true` : le serveur a coupe l'export a son plafond. */
export const exportIsTruncated = (headers: Headers): boolean => headers.get('X-Truncated') === 'true';

export const saveFile = (file: DownloadedFile): string => {
  const filename = exportFilename(file.headers);
  const url = URL.createObjectURL(file.blob);
  const anchor = document.createElement('a');

  anchor.href = url;
  anchor.download = filename;
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  // Révoquée après le tour de boucle : certains navigateurs lisent l'URL après
  // le retour de `click()`.
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 0);

  return filename;
};
